/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const SquareArrowRightExit = [
  ["path", { d: "M10 12h11" }],
  ["path", { d: "m17 16 4-4-4-4" }],
  [
    "path",
    { d: "M21 6.344V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1.344" }
  ]
];

export { SquareArrowRightExit as default };
//# sourceMappingURL=square-arrow-right-exit.js.map
